import gql from 'graphql-tag'

export const fetchTransportTypeMutation = gql(`
mutation ($cart_id: String!, $transporttype: String!, $outletid: Int!, 
$datepopup: String!, $sappaymentmethod: String!, 
$sappaymentcode: String!,$store: String!
) {
  setTransportType(
      cart_id: $cart_id
      transporttype: $transporttype
      outletid: $outletid
      datepopup: $datepopup
      store: $store
      sappaymentmethod: $sappaymentmethod
      sappaymentcode: $sappaymentcode
  ) {
    message
  }
}
`)
